import React from 'react';

function FilmImage( { path, alt, w, renderHeight} ){
  return <img style={renderHeight && {height: renderHeight,}} src={"https://image.tmdb.org/t/p/w" + w + path} alt={alt} />
}

export default FilmImage;
